import React, { useState } from 'react';
import './CredentialGeneratorModal.css';
import CourseSelectionModal from './CourseSelectionModal';

const CredentialGeneratorModal = ({ isOpen, onClose, onCredentialsGenerated, programName }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [showCourseSelection, setShowCourseSelection] = useState(false);

  if (!isOpen) return null;

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleNext = () => {
    if (selectedOption === 'course') {
      setShowCourseSelection(true);
    } else if (selectedOption === 'material') {
      // Handle course material flow
      console.log('Course material flow not implemented yet');
      onClose();
    }
  };

  const handleCancel = () => {
    setSelectedOption(null);
    onClose();
  };

  const handleBackFromCourseSelection = () => {
    setShowCourseSelection(false);
  };

  const handleCloseCourseSelection = () => {
    setShowCourseSelection(false);
    setSelectedOption(null);
    onClose();
  };

  return (
    <div className="credential-modal-overlay">
      <div className="credential-modal">
        {/* Close Button */}
        <button className="close-button" onClick={onClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        {/* Header */}
        <div className="modal-header">
          <h2 className="modal-title">Credential Generator</h2>
          <p className="modal-description">Select a course or course materials to generate an academic credential</p>
        </div>

        {/* Options */}
        <div className="options-container">
          {/* Course Option */}
          <div 
            className={`option-card ${selectedOption === 'course' ? 'selected' : ''}`}
            onClick={() => handleOptionSelect('course')}
          >
            <div className="option-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6.5 2H20V22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.7989 4 20.163 4 19.5V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2Z" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 className="option-title">Course</h3>
            <p className="option-description">Select from available university courses</p>
          </div>

          {/* Course Material Option */}
          <div 
            className="option-card disabled"
          >
            <div className="option-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M10 9H9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 className="option-title">Course Material</h3>
            <p className="option-description">Select from study materials and resources (Coming soon)</p>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="action-buttons">
          <button className="cancel-button" onClick={handleCancel}>
            Cancel
          </button>
          <button 
            className={`generate-button ${selectedOption ? 'enabled' : 'disabled'}`}
            onClick={handleNext}
            disabled={!selectedOption}
          >
            Next
          </button>
        </div>
      </div>
      
      {/* Course Selection Modal */}
      <CourseSelectionModal 
        isOpen={showCourseSelection}
        onClose={handleCloseCourseSelection}
        onBack={handleBackFromCourseSelection}
        onCredentialsGenerated={onCredentialsGenerated}
        programName={programName}
      />
    </div>
  );
};

export default CredentialGeneratorModal;
